import styled from "styled-components";
import { IMAGES } from "../../../constants/images";
import ZoomControls from "./ZoomControls";
import { useEffect } from "react";
import { useMap } from "../../../hooks/useMap";

export default function MapControls({ isFullScreen, handleFullScreen, bearing }) {
  const map = useMap();

  useEffect(() => {
    map.resize();
    if (isFullScreen) {
      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = `${scrollBarWidth}px`;
      map.on("wheel", () => {
        map.scrollZoom.enable();
      });
    } else {
      map.on("wheel", (event) => {
        if (event.originalEvent.ctrlKey) {
          map.scrollZoom.enable();
        } else {
          map.scrollZoom.disable();
        }
      });
    }

    return () => {
      document.body.style.overflow = "auto";
      document.body.style.paddingRight = "0px";
    };
  }, [isFullScreen, map]);

  return (
    <>
      <MapFullscreenButton onClick={handleFullScreen}>
        {isFullScreen ? <img src={IMAGES.PARTSCREEN} alt="fullscreen" /> : <img src={IMAGES.FULLSCREEN} alt="fullscreen" />}
      </MapFullscreenButton>
      <ZoomControlsContainer>
        <ZoomControls bearing={bearing} />
      </ZoomControlsContainer>
    </>
  );
}

const MapFullscreenButton = styled.button`
  all: unset;
  position: absolute;
  bottom: 42px;
  right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  background-color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  color: rgba(0, 0, 255, 1);
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #f5f5f5;
  }

  img {
    width: 20px;
  }
`;

const ZoomControlsContainer = styled.div`
  position: absolute;
  bottom: 82px;
  right: 15px;
  z-index: 2;
`;
